"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insightSanitize = void 0;
// (C) 2020 GoodData Corporation
var ts_invariant_1 = require("ts-invariant");
var _1 = require(".");
var buckets_1 = require("../execution/buckets");
var sort_1 = require("../execution/base/sort");
var attribute_1 = require("../execution/attribute");
/**
 * Makes sure the insight does not have any nonsensical data (like totals that no longer make sense, etc.), before it is saved.
 *
 * @param insight - the insight or insight definition to sanitize
 * @public
 */
function insightSanitize(insight) {
    return removeInvalidTotals(insight);
}
exports.insightSanitize = insightSanitize;
function removeInvalidTotals(insight) {
    var sortItems = _1.insightSorts(insight);
    var attributeIdentifiers = _1.insightAttributes(insight).map(attribute_1.attributeLocalId);
    var sanitizedBuckets = _1.insightBuckets(insight).map(function (bucket) {
        var totals = buckets_1.bucketTotals(bucket);
        if (totals.length && isSortedOnDifferentThanFirstAttributeInBucket(bucket, sortItems)) {
            bucket.totals = getBucketTotalsWithoutSubtotals(bucket);
            if (totals.length === 0) {
                return buckets_1.bucketSetTotals(bucket, []);
            }
        }
        var sanitizedTotals = totals.filter(function (total) {
            return attributeIdentifiers.includes(total.attributeIdentifier);
        });
        if (sanitizedTotals.length !== totals.length) {
            return buckets_1.bucketSetTotals(bucket, sanitizedTotals);
        }
        return bucket;
    });
    return _1.insightSetBuckets(insight, sanitizedBuckets);
}
function isSortedOnDifferentThanFirstAttributeInBucket(bucket, sortItems) {
    return sortItems.some(function (sortItem) {
        if (sort_1.isAttributeSort(sortItem)) {
            var attributeIdentifier = sort_1.sortEntityIds(sortItem).attributeIdentifiers[0];
            var attributeIndex = buckets_1.bucketAttributeIndex(bucket, attributeIdentifier);
            return attributeIndex > 0;
        }
        else if (sort_1.isMeasureSort(sortItem)) {
            return true;
        }
        throw new ts_invariant_1.InvariantError('Unexpected sortType, only supported sortTypes are "attributeSortItem" and "measureSortItem"');
    });
}
function getBucketTotalsWithoutSubtotals(bucket) {
    return buckets_1.bucketTotals(bucket).filter(function (total) { return buckets_1.bucketAttributeIndex(bucket, total.attributeIdentifier) === 0; });
}
//# sourceMappingURL=sanitization.js.map